export default __webpack_public_path__ + "static/retreat_14-697262636242a0c74d7862242c51ff48.jpg";